const e = {
  add: "Lisää",
  cancel: "Peruuta",
  clear: "Tyhjennä",
  confirm: "Vahvista",
  delete: "Poista",
  redo: "Tee uudelleen",
  save: "Tallenna",
  saveAs: "Tallenna nimellä",
  undo: "Kumoa"
}, a = {
  completed: "Completed",
  notCompleted: "Not completed",
  progressSteps: "Progress steps",
  stepOf: "Step {0} of {1}",
  percentComplete: "{0}{1} complete. Step {2} of {3}"
}, t = {
  cancel: "Peruuttaa",
  confirm: "Vahvista",
  datePlaceholder: "Valitse päivämäärä",
  datetimePlaceholder: "Valitse päivämäärä ja kellonaika",
  endDatePlaceholder: "Päättymispäivä",
  endDatetimePlaceholder: "Päättymispäivä ja -kellonaika",
  endMonthPlaceholder: "Päättymiskuukausi",
  monthPlaceholder: "Valitse kuukausi",
  now: "Nyt",
  quarterPlaceholder: "Valitse vuosineljännes",
  selectDate: "Valitse päivämäärä",
  selectTime: "Valitse kellonaika",
  startDatePlaceholder: "Alkamispäivä",
  startDatetimePlaceholder: "Alkamispäivä ja -kellonaika",
  startMonthPlaceholder: "Alkamiskuukausi",
  today: "Tänään",
  weekPlaceholder: "Valitse viikko",
  yearPlaceholder: "Valitse vuosi",
  chooseDateAriaLabel: "Choose Date",
  backToDateSelectionAriaLabel: "Back to Date Selection"
}, l = {
  placeholder: "Valitse"
}, o = {
  clear: "Tyhjennä",
  negativeText: "Peruuta",
  now: "Nyt",
  placeholder: "Valitse kellonaika",
  positiveText: "OK"
}, i = {
  placeholder: "Lisää"
}, s = {
  placeholder: "Lisää"
}, n = {
  placeholder: "Aloita kirjoittaminen..."
}, r = {
  allRows: "Kaikki rivit",
  default: "Oletus",
  deleteLayoutDescription: "Haluatko varmasti poistaa tämän asettelun?",
  discardChanges: "Hylkää muutokset",
  discardLayoutChanges: "Hylkää asettelumuutokset",
  enterLayoutName: "Anna asettelun nimi",
  enterRowNumber: "Anna rivien lukumäärä",
  fieldsSelected: "kenttää valittu",
  freezeColumnDescription: "Lukitse vasemmanpuoleinen sarake",
  freezeUptoColumn: "Lukitse sarakkeeseen asti",
  frozen: "Lukittu",
  layoutName: "Asettelun nimi",
  manageColumns: "Hallitse sarakkeita",
  none: "Ei mitään",
  reorderRows: "Järjestä rivit uudelleen",
  rowsSelected: "riviä valittu",
  saveLayoutAs: "Tallenna asettelu nimellä",
  saveLayoutNew: "Tallenna uusi asettelu",
  search: "Haku",
  searchColumnsPlaceholder: "Hakusarakkeet",
  searchFieldsPlaceholder: "Hakukentät",
  selectAll: "Valitse kaikki",
  setTableHeight: "Aseta pöydän korkeus",
  unfreeze: "Poista lukitus",
  unsavedChanges: "Sinulla on tallentamattomia muutoksia",
  unsavedChangesDescription: "Tallentamattomia muutoksia saattaa olla yksi tai useampi. Haluatko tallentaa ne?"
}, u = {
  at: "klo",
  colorAlreadyUsed: "Valitse eri sävy tai käytä olemassa olevaa",
  colorNamePlaceholder: "Lisää nimi",
  customPlaceholder: "{{ Custom }}",
  nameAlreadyUsed: "Valitse toinen värin nimi",
  noColorsAdded: "Sinulla ei ole värejä tässä osiossa."
}, c = {
  searchPlaceholder: "Haku"
}, d = {
  invalidPastedData: "Virheelliset liitetyt tiedot"
}, k = {
  of: "/",
  page: "Sivu",
  rowsPerPage: "Rivejä per sivu"
}, m = {
  failedToUpload: "Lataus epäonnistui",
  retry: "Yritä uudelleen",
  clickToUpload: "napsauttaa Ladataan",
  orDragAndDrop: "Tai Vetää ja pudota",
  supportedFileTypes: "Tuetut tiedostotyypit:"
}, p = {
  global: e,
  Progress: a,
  DatePicker: t,
  Select: l,
  TimePicker: o,
  Input: i,
  InputNumber: s,
  InputTag: n,
  HLDataTable: r,
  ColorPicker: u,
  InputPhone: c,
  InputOtp: d,
  Pagination: k,
  Upload: m
};
export {
  u as ColorPicker,
  t as DatePicker,
  r as HLDataTable,
  i as Input,
  s as InputNumber,
  d as InputOtp,
  c as InputPhone,
  n as InputTag,
  k as Pagination,
  a as Progress,
  l as Select,
  o as TimePicker,
  m as Upload,
  p as default,
  e as global
};
